import { render, staticRenderFns } from "./HistoryDetails.vue?vue&type=template&id=8deaee08&"
import script from "./HistoryDetails.vue?vue&type=script&lang=js&"
export * from "./HistoryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports